module.exports = __webpack_public_path__ + "static/media/bg3.ff13001e.jpg";